<template>
  <div
    class="legal-doc-seal"
    role="img"
    aria-label="IpromiseAfrica official company seal — binding legal document"
  >
    <div class="legal-doc-seal__glow" aria-hidden="true" />
    <div class="legal-doc-seal__ring" aria-hidden="true">
      <img
        class="legal-doc-seal__img"
        src="@/assets/company-seal.png"
        width="160"
        height="160"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </div>
    <span class="legal-doc-seal__badge" aria-hidden="true">Official</span>
    <span class="legal-doc-seal__sub" aria-hidden="true">Enforced policy</span>
  </div>
</template>

<script>
export default {
  name: "LegalDocumentSeal",
};
</script>

<style scoped>
.legal-doc-seal {
  position: absolute;
  top: clamp(10px, 2.5vw, 26px);
  right: clamp(10px, 2.5vw, 28px);
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  filter: drop-shadow(0 10px 22px rgba(0, 0, 0, 0.35));
}

.legal-doc-seal__glow {
  position: absolute;
  width: clamp(88px, 18vw, 150px);
  height: clamp(88px, 18vw, 150px);
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 215, 0, 0.35) 0%,
    rgba(255, 215, 0, 0.08) 45%,
    transparent 70%
  );
  animation: seal-glow 3.5s ease-in-out infinite alternate;
}

@keyframes seal-glow {
  from {
    opacity: 0.65;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1.05);
  }
}

.legal-doc-seal__ring {
  position: relative;
  padding: 5px;
  border-radius: 50%;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 215, 0, 0.35) 40%,
    rgba(180, 140, 40, 0.45) 100%
  );
  box-shadow:
    0 0 0 2px rgba(0, 0, 0, 0.2),
    inset 0 0 0 1px rgba(255, 255, 255, 0.35);
  animation: seal-land 0.85s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes seal-land {
  from {
    opacity: 0;
    transform: rotate(-34deg) scale(0.45);
  }
  to {
    opacity: 1;
    transform: rotate(-12deg) scale(1);
  }
}

.legal-doc-seal__img {
  display: block;
  width: clamp(72px, 14vw, 132px);
  height: auto;
  border-radius: 50%;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.06);
}

.legal-doc-seal__badge {
  margin-top: 6px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #fff;
  text-shadow:
    0 1px 2px rgba(0, 0, 0, 0.85),
    0 0 12px rgba(255, 215, 0, 0.45);
  transform: rotate(-3deg);
}

.legal-doc-seal__sub {
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.82);
  margin-top: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.75);
  transform: rotate(-2deg);
}

@media (max-width: 520px) {
  .legal-doc-seal {
    top: 6px;
    right: 6px;
  }

  .legal-doc-seal__badge,
  .legal-doc-seal__sub {
    display: none;
  }

  .legal-doc-seal__ring {
    padding: 3px;
  }
}
</style>
